import React, { useState, useRef } from 'react';
import { Link, Redirect, useHistory } from 'react-router-dom';
import axios from 'axios';
import { GoogleLogin } from '@react-oauth/google';
import AppleSignin from 'react-apple-signin-auth';

export default function Login({ refreshUser }) {
  const formLogin = useRef(null);
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [login, setLogin] = useState({
    email: '',
    password: '',
  });

  const getParamFromUrl = async (param = "") => {
    const url = new URL(window.location.href);
    return url.searchParams.get(param)
  };

  const responseApple = async (response) => {
    try {
      const { authorization, user } = response;
      const payload = {
        identity_token: authorization.id_token,
        email: user?.email ?? null,
        name: user?.name ? `${user.name.firstName ?? ''} ${user.name.lastName ?? ''}`.trim() : null,
      };

      const { data } = await axios.post('customers/apple-login', payload);

      localStorage.setItem('user', JSON.stringify(data));
      axios.defaults.headers.common['Authorization'] = data.api_token;
      await refreshUser();

      const id_produto = await getParamFromUrl('product');
      if (id_produto && data.verified) {
        window.location.href = '/loja/add?&product_id=' + id_produto;
        return;
      }

      const redirect = await getParamFromUrl('redirect');
      if (redirect && data.verified) {
        window.location.href = decodeURIComponent(redirect);
        return;
      }
      window.location.href = data.verified ? '/' : '/perfil/editar';
    } catch (err) {
      alert('Ops, não foi possível entrar com a Apple.');
    }
  };

  const responseGoogle = async (credentialResponse) => {
    try {
      const { data } = await axios.post('customers/google-login', {
        id_token: credentialResponse.credential,
      });

      localStorage.setItem('user', JSON.stringify(data));
      axios.defaults.headers.common['Authorization'] = data.api_token;
      await refreshUser();

      const id_produto = await getParamFromUrl('product');
      if (id_produto && data.verified) {
        window.location.href = '/loja/add?&product_id=' + id_produto;
        return;
      }

      const redirect = await getParamFromUrl('redirect');
      if (redirect && data.verified) {
        window.location.href = decodeURIComponent(redirect);
        return;
      }
      window.location.href = data.verified ? '/' : '/perfil/editar';
    } catch (err) {
      alert('Ops, não foi possível entrar com o Google.');
    }
  };

  const responseFacebook = async (response) => {
    if (!response.id) {
      return false;
    }
    console.log(response);
    const user = {
      facebook_id: response.id,
      name: response.name,
      email: response.email,
      image: response.picture.data.url,
    }

    localStorage.setItem('userFacebook', JSON.stringify(user));

    try {
      const send = {
        facebook_id: user.facebook_id,
        email: user.email,
      }

      const { data } = await axios.post('customers/login', send);

      localStorage.setItem('user', JSON.stringify(data));
      axios.defaults.headers.common['Authorization'] = data.api_token;
      let id_produto = await getParamFromUrl('product');
      const options = { allowLocalhostAsSecureOrigin: true, requiresUserPrivacyConsent: true }
      // OneSignal.initialize("23934880-54a9-40cd-9e43-ba34b7169dce", options);
      // OneSignal.sendTag("customer", data.id);
      // OneSignal.setExternalUserId(data.id);
      await refreshUser();
      if (id_produto) {
        window.location.href = '/loja/add?&product_id=' + id_produto;
        // history.push('/loja/add?&product_id='+id_produto)
      } else {
        const redirect = await getParamFromUrl('redirect');
        if (redirect && data.verified === 1) {
          window.location.href = decodeURIComponent(redirect);
        } else {
          window.location.href = data.verified === 1 ? "/" : "/cadastro/token";
        }
      }

    } catch (err) {
      // window.location.href = "/cadastro";
      history.push("/cadastro")
      console.log(err.response)
    }
  }

  const logar = async (e) => {
    try {
      e.preventDefault();
      setLoading(true);
      const send = {
        email: login.email,
        password: login.password
      }
      const { data } = await axios.post('customers/login', send)
      localStorage.setItem('user', JSON.stringify(data));
      axios.defaults.headers.common['Authorization'] = data.api_token;

      let id_produto = await getParamFromUrl('product');
      const options = { allowLocalhostAsSecureOrigin: true, requiresUserPrivacyConsent: true }
      // OneSignal.initialize("23934880-54a9-40cd-9e43-ba34b7169dce", options);

      // OneSignal.setExternalUserId(data.id);
      // OneSignal.sendTag("customer", data.id);
      await refreshUser();
      if (id_produto) {
        // history.push('/loja/add?&product_id='+id_produto)
        window.location.href = '/loja/add?&product_id=' + id_produto;
      } else {
        localStorage.setItem('userDados', JSON.stringify(data));
        const redirect = await getParamFromUrl('redirect');
        if (redirect && data.verified === 1) {
          window.location.href = decodeURIComponent(redirect);
        } else {
          window.location.href = data.verified === 1 ? "/" : "/cadastro/token";
        }
      }

      setLoading(false);
    } catch (err) {
      alert('Ops, o e-mail ou a senha estão incorretos!');
      setLoading(false);
      console.log(err);
    }
  };

  return (
    <div className="content login">
      <div className="loginTitle">Olá! Bem-vindo!</div>
      <div className="loginText">Entre com sua conta para continuar</div>
      <form ref={formLogin} onSubmit={logar}>
        <div className="ui-input-title">E-mail</div>
        <input
          value={login.email}
          onChange={(e) => setLogin({ ...login, email: e.target.value })}
          className="ui-input"
          placeholder="seu@email.com"
          type="email"
          required
        />
        <div className="ui-input-title">Senha</div>
        <input
          value={login.password}
          onChange={(e) => setLogin({ ...login, password: e.target.value })}
          className="ui-input"
          placeholder="Sua senha"
          type="password"
          required
        />
        <div className="forgotPassword">
          <Link to="/esqueci-a-senha">Esqueci a senha</Link>
        </div>
        <button className="loginSubmitBtn" type="submit" disabled={loading}>
          {loading ? 'Entrando...' : 'Entrar'}
        </button>
      </form>
      <div className="otherOption">ou entre com</div>
      <div className="loginButtons">
        <GoogleLogin
          onSuccess={responseGoogle}
          onError={() => alert('Falha no login com Google.')}
          width="350"
        />
        <AppleSignin
          authOptions={{
            clientId: process.env.REACT_APP_APPLE_CLIENT_ID,
            scope: 'email name',
            redirectURI: process.env.REACT_APP_APPLE_REDIRECT_URI,
            usePopup: true,
          }}
          onSuccess={responseApple}
          onError={() => alert('Falha no login com Apple.')}
          render={(props) => (
            <button {...props} className="apple-login-btn" type="button">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
              </svg>
              <span>Fazer Login com a Apple</span>
            </button>
          )}
        />
      </div>
      <div className="hasAccount">
        Ainda não tem conta?{' '}
        <Link to="/cadastro">Cadastre-se</Link>
      </div>
    </div>
  )
}
